var map = {
	"./三色堇.jpg": 71737,
	"./乒乓菊.jpg": 64454,
	"./乾草飼料.jpg": 54765,
	"./分岔白蘿蔔.jpg": 45324,
	"./南瓜.jpg": 30189,
	"./可可豆.jpg": 22763,
	"./向日葵.jpg": 12970,
	"./咖啡豆.jpg": 16354,
	"./哈密瓜.jpg": 24092,
	"./圓球茄子.jpg": 25826,
	"./報春花.jpg": 22065,
	"./大蒜.jpg": 2954,
	"./富貴菊.jpg": 55585,
	"./小麥.jpg": 72835,
	"./小黃瓜.jpg": 40173,
	"./巨大番茄.jpg": 16058,
	"./巨大的青蔥.jpg": 90621,
	"./巨大蕃薯.jpg": 64290,
	"./巨大蕪菁.jpg": 58925,
	"./巨大酪梨.jpg": 75151,
	"./彩色玉蜀黍.jpg": 57191,
	"./愛心菠菜.jpg": 80518,
	"./扶桑花.jpg": 33802,
	"./星型馬鈴薯.jpg": 99235,
	"./杏仁.jpg": 67450,
	"./柳橙.jpg": 14854,
	"./桃子.jpg": 23973,
	"./椰子.jpg": 9286,
	"./橄欖.jpg": 37779,
	"./檸檬.jpg": 98100,
	"./櫛瓜.jpg": 60814,
	"./櫻桃.jpg": 8947,
	"./櫻桃蘿蔔.jpg": 92933,
	"./洋蔥.jpg": 72292,
	"./牛蒡.jpg": 45273,
	"./玉蜀黍.jpg": 24162,
	"./玫瑰.jpg": 44105,
	"./珠寶哈密瓜.jpg": 9622,
	"./瑪格麗特.jpg": 84174,
	"./甜椒.jpg": 66288,
	"./番茄.jpg": 23391,
	"./白菜.jpg": 97036,
	"./白蘿蔔.jpg": 14632,
	"./百合.jpg": 85780,
	"./矮牽牛.jpg": 97740,
	"./秋海棠.jpg": 42476,
	"./秋葵.jpg": 58139,
	"./稻米.jpg": 98080,
	"./粉蝶花.jpg": 70811,
	"./綠花椰菜.jpg": 95151,
	"./羊毛.jpg": 51038,
	"./羊毛毛料.jpg": 36783,
	"./羊毛線.jpg": 98212,
	"./聖誕玫瑰.jpg": 4708,
	"./胡蘿蔔.jpg": 91243,
	"./芒果.jpg": 63649,
	"./茄子.jpg": 66629,
	"./茶葉.jpg": 53356,
	"./草莓.jpg": 52155,
	"./菠菜.jpg": 72392,
	"./萬壽菊.jpg": 80145,
	"./葡萄.jpg": 93319,
	"./蕃薯.jpg": 59250,
	"./蕪菁.jpg": 10818,
	"./蘋果.jpg": 5206,
	"./西瓜.jpg": 2566,
	"./豆子.jpg": 49612,
	"./辣椒.jpg": 12884,
	"./酪梨.jpg": 79243,
	"./鐵線蓮.jpg": 27662,
	"./陸蓮花.jpg": 1569,
	"./青椒.jpg": 98773,
	"./青江菜.jpg": 88900,
	"./青蔥.jpg": 83246,
	"./頂級羊毛.jpg": 11470,
	"./風鈴草.jpg": 72057,
	"./香蕉.jpg": 77917,
	"./馬鈴薯.jpg": 60796,
	"./高麗菜.jpg": 64316,
	"./鬱金香.jpg": 40234,
	"./鳳梨.jpg": 1278,
	"./黃金桃子.jpg": 32961,
	"./黃金白菜.jpg": 21797,
	"./黃金草莓.jpg": 74503,
	"./黃金蘋果.jpg": 70672,
	"./黑色三色堇.jpg": 76206,
	"./黑薔薇.jpg": 83618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99857;